const RANK = {
    PUBLIC: 1,
    PRIVATE: 2,
    SACRED: 3,
};
export function visibilityRank(v) {
    return RANK[v];
}
/** True iff a source declared at `source.visibility` can mount on `mount`. */
export function canSourceMountOn(source, mount) {
    return RANK[source.visibility] <= RANK[mount];
}
//# sourceMappingURL=index.js.map